import axios from '../axios'
import request_url from '../../assest/utils/request_url'
let baseUrl = request_url('enterpriseRecord')
let ossUrl = request_url('ossConfig')
export default {
  // 获取资源
  getAllResource() {
    return axios.get(`${baseUrl}/brd/realEstateAgencyPlatform/resource/listPart`)
  },
  // 获取oss配置
  getOssConfig(type) {
    return axios.get(`${ossUrl}/oss/miniAppStsToken/${type}`,)
  }
}
